import * as Passengers from './components/Passengers/Passengers.css';
var theme = {
    Passenger: {
        Switch: {
            error: Passengers.switch_error
        }
    },
    TravellerForm: {
        TravellerForm: {
            sex: Passengers.travellerForm__sex
        }
    }
};
export default theme;
